import React, { FC } from 'react';
import { FormSelect } from '@ch/common/components/form/select';
import { Question } from '@ch/common/types/data';
import { useQuizAutocomplete } from './hooks/use-quiz-autocomplete';

const QuizFieldAutocomplete: FC<Question> = props => {
  const { identifier: name, placeholder, disabled } = props;
  const { options, handleInputChange, onFocus, isLoading } = useQuizAutocomplete(props);
  return (
    <FormSelect
      {...{
        name,
        hideError: true,
        options,
        isMulti: false,
        placeholder,
        disabled,
        onFocus,
        isLoading,
        onInputChange: handleInputChange,
      }}
    />
  );
};

export default QuizFieldAutocomplete;
